__webpack_require__.p = "/colors-of-princeton/";